module.exports = __webpack_public_path__ + "static/media/logo.b01adb9d.svg";